import { NgModule } from '@angular/core';
import { FlipTextComponent } from './flip-text.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        FlipTextComponent
    ],
    imports: [CommonModule],
    exports: [
        FlipTextComponent
    ]
})
export class NcFlipTextModule { }